module.exports = __webpack_public_path__ + "5b8aade08dcfbb45e3eb7d2d796eaa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/iosys.png
// module id = 74
// module chunks = 0